/// <reference path="../../../../typings/index.d.ts" />
angular.module('app').factory('SettlementServiceApi', ($http, ApiErrorService) => {
    return {
        settlementTesters: settlementTesters,
        testers: testers,
        sims: sims,
        search: search,
        addRequest: addRequest,
        testerSettlementFiles: testerSettlementFiles,
        updatedSettlementFiles: updatedSettlementFiles,
        processTraces: processTraces
    };
    function settlementTesters(user) {
        return $http.post(`api/Settlement/SettlementTesters`, user)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function testers() {
        return $http.post(`api/Settlement/Testers`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function sims(testerId) {
        return $http.post(`api/Settlement/Sims?testerId=${testerId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function search(req) {
        return $http.post(`api/Settlement/Count`, req)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function addRequest(req) {
        return $http.post(`api/Settlement/AddRequest`, req)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function testerSettlementFiles(testerId) {
        return $http.post(`api/Settlement/TesterSettlementFiles?testerId=${testerId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function updatedSettlementFiles(newIds) {
        return $http.post(`api/Settlement/UpdatedSettlementFiles?newIds=${newIds}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function processTraces(settlementFileId) {
        return $http.post(`api/Settlement/ProcessTraces?settlementFileId=${settlementFileId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
});
